import(/* webpackMode: "eager" */ "/var/directorder/app/staging/apps/admin/src/app/layout.js");
